import { useEffect, useRef } from 'react';
import { pollingService } from '@/services/PollingService';

/**
 * Hook to subscribe to a polling service topic.
 * @param topic Unique key for the resource
 * @param fetchFn Async function to fetch data
 * @param onData Callback for when data is received
 * @param interval Polling interval in ms (default 5000)
 * @param dependencyArray Dependencies to re-trigger subscription
 */
export const usePollingSubscription = (
    topic: string,
    fetchFn: () => Promise<any>,
    onData: (data: any) => void,
    interval: number = 5000,
    dependencyArray: any[] = []
) => {
    // Use refs to keep latest callbacks without restarting subscription
    const onDataRef = useRef(onData);
    const fetchFnRef = useRef(fetchFn);

    useEffect(() => {
        onDataRef.current = onData;
        fetchFnRef.current = fetchFn;
    }, [onData, fetchFn]);

    useEffect(() => {
        if (!topic) return;

        const id = pollingService.subscribe(
            topic,
            () => fetchFnRef.current(),
            (data) => onDataRef.current(data),
            interval
        );

        return () => {
            pollingService.unsubscribe(id);
        };
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [topic, interval, ...dependencyArray]);
};
